import { useState } from "react";
import { GiPowerButton } from "react-icons/gi";
import { FiAlertCircle } from "react-icons/fi";
import { BiDownArrow } from "react-icons/bi";
import { Link } from "react-router-dom";
import "./NavbarDawn.css";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const NavbarDawn = () => { 
  const [isHovering, setIsHovering] = useState(false);
  const navigate = useNavigate();

  const handleOpenNavbar = () => {
    setIsHovering(!isHovering);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    navigate("/");
  }

  return (
    <div className="box-navbardawn">
      <div className="box-user-dawn-navbar" onClick={handleOpenNavbar}>
        <p className="tittle-user">
          Amebo User <BiDownArrow id="first-icon-navbar-dawn" />
        </p>
      </div>
      {isHovering && (
        <div className="navbarviewtrue">
          <Link to="/alertas">
            <div className="box-ref-navbardawn">
              <FiAlertCircle className="icon-navbardawn" />
              <p className="text-navbar-dawn">Alertas</p>
            </div>
          </Link>

          <Link to="/perfil">
            <div className="box-ref-navbardawn">
              <FiAlertCircle className="icon-navbardawn" />
              <p className="text-navbar-dawn">Perfil</p>
            </div>
          </Link>
          <div className="box-ref-navbardawn2" onClick={handleLogout}>
            <GiPowerButton className="icon-navbardawn" />
            <p className="text-navbar-dawn">Salir</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavbarDawn;